import {APIENDPOINT} from '../constants';
var APIURL = window.bookingsUrl + APIENDPOINT;

export default {
  init() {
    var AUTH = window.AUTH;
    var strings = window.location.pathname.split('\/');
    var paths = [];
    strings.forEach(function (string) {
      if (string.length > 0) {
        paths.push(string);
      }
    });
    var bookingId = paths[paths.length - 1];
    var $bookingContainer = $('.booking-container');
    $.ajax({
      url: APIURL + 'bookings/' + bookingId,
      method: 'GET',
      beforeSend: function (req) {
        req.setRequestHeader('Authorization', AUTH);
      },
      success: function (booking) {
        var room = booking._embedded.room;
        var calFromDate=booking.from.replace(/\s/, 'T').replace(/-/g, '').replace(/:/g, '');
        var calToDate=booking.to.replace(/\s/, 'T').replace(/-/g, '').replace(/:/g, '');
        
        var fromDate = new Date(booking.from.replace(/\s/, 'T')+'Z');
        var toDate = new Date(booking.to.replace(/\s/, 'T')+'Z');

        var dateString = (fromDate.getUTCHours() < 10 ? '0' : '') + fromDate.getUTCHours() + ':' + (fromDate.getUTCMinutes() < 10 ? '0' : '') + fromDate.getUTCMinutes() + ' - ' + (toDate.getUTCHours() < 10 ? '0' : '') + toDate.getUTCHours() + ':' + (toDate.getUTCMinutes() < 10 ? '0' : '') + toDate.getUTCMinutes() + ', ' + $.datepicker.formatDate('d M, yy', toDate)
        var roomBodyHtml = room.body.replace(/\<br \/>/g, ' \/\/ ');
        
         var now = new Date();
         now.setHours(24,0,0,0);		   
		 var noCatering=true;
		  var diffDays = parseInt((fromDate - now) / (1000 * 60 * 60 * 24), 10);
		  if(diffDays>=1 && fromDate.getUTCHours()>=catering_opening_time && fromDate.getUTCHours()<=catering_closing_time){
			 noCatering=false;
		  }

		  console.log(catering_opening_time);
		  console.log(catering_closing_time);
        
        var roomInfo = `
        <div class="text-left flex">
        <div class="hidden md:inline-flex w-3/5 mt-12 flex-col text-left room-content">
                  <div class="flex items-center">
                    <h3>${room.title}</h3>
                    <img src="${HOME_URL}/wp-content/themes/epicenter/images/people-icon-black.svg" class="self-start h-6 ml-2" />
                    <p class="text-xl ml-2">${room.capacity}</p>
                  </div>
                  <span class="h-border bg-black rounded-full w-full mr-12 my-4">&nbsp;</span>
                    ${roomBodyHtml}
        </div>
        </div>
                `;

        var html = `
	        <div class="w-full md:rounded-lg overflow-hidden bg-white flex md:flex-row flex-col mb-6 mt-8">
             <div class="flex">
              <div class="md:w-64 w-2/5 h-auto" style="background: url('${room.photo}') center center no-repeat; background-size: cover;">&nbsp;</div>
              <div class="md:hidden flex p-6 w-3/5 room-content-mobile">
                <div class="flex flex-col">
                  <div class="flex items-end">
                    <h3>${room.title}</h3>
                    <img src="${HOME_URL}/wp-content/themes/epicenter/images/people-icon-black.svg" class="self-start h-6 ml-auto" />
                    <p class="text-xl ml-2">${room.capacity}</p>
                  </div>
                  <span class="h-border bg-black rounded-full w-full my-2">&nbsp;</span>
                  ${roomBodyHtml}
                </div>
              </div>
            </div>
            <!-- final view -->
            <div class="w-full p-6 text-right text-left flex-col">
               <p class="font-bold alschlange mb-4 text-center md:text-left text-base md:text-xl text-secondary-dark">Chosen time</p>
               <p class="chosen-date text-secondary-dark text-lg md:text-4xl text-center alschlange md:text-left">${dateString}</p>
               <p class="passcode-text text-black text-lg dinpromedium md:text-xl text-center md:text-left mt-4 text-left mb-8">PASSCODE: ${booking.roomDoorCode}</p>
               <p class="mt-4 mb-4 text-left text-base leading-tight md:leading-normal md:text-xl text-black">Please note that the door passcode may have changed at the start of the booking, so please have a look at your upcoming activities before your meeting.</p>
               <div class="flex">
               <button class="mt-4 edit-this-booking mr-8 rounded-full bg-transparent border-2 border-black text-black text-xl px-16 md:px-10 cta">EDIT BOOKING</button>
               
               
               <a href="${HOME_URL}/wp-admin/admin-ajax.php?action=create_calender_file&passcode=${booking.roomDoorCode}&room=${room.title}&dateStart=${calFromDate}&dateEnd=${calToDate}">
               <button class="mt-4 rounded-full bg-transparent border-2 border-black text-black text-xl px-16 md:px-10 cta">Add to calendar</button>
               </a>

               </div>
                  ${roomInfo}
           </div>
           </div>`;
		   
		   
		  
		   if(!noCatering){
        html += `
          <div class="hidden edit-view flex-col">
             <h4 class="font-bold mt-8 text-center text-2xl alschlange text-secondary-dark">Do you want to order anything to the meeting?</h4>
             <div class="mx-auto max-w-xl">
             <div class="text-center my-4">
                <label name="catering" class="relative inline-block w-16 h-8 ${booking.catering ? 'active' : ''}"><input ${booking.catering ? 'checked' : ''} class="catering-slider" type="checkbox" /><span class="absolute pin bg-secondary-light rounded-full slider"></span><span class="absolute text-secondary-dark pin-t pin-b pin-l select-text-position text-left slider-on opacity-0 text-white text-xs mx-3">YES</span><span class="absolute pin-t pin-b pin-r select-text-position edit-profile slider-off text-xs text-white mx-3">NO</span></label>
             </div>
                <div class="catering-container mt-8" ${booking.catering ? '' : 'style="display: none;"'}>
                  <div class="md:px-20 px-0">
                    <label for="catering-message" class="text-left text-black alschlange text-lg">Catering request</label>
                    <textarea name="catering-message" class="catering-message mt-1 dinpromedium p-4 w-full min-h-80 bg-white rounded-lg" placeholder="3 water at start&#10;3 coffe at start&#10;3 lunch at 12:00" >${booking.cateringRequest != null ? booking.cateringRequest : ''}</textarea>
                    <p class="mt-4 text-black text-left text-lg font-bold alschlange leading-tight leading-normal">Last order/cancellation time 12:00 two working days before delivery.</p>
                    <p class="mt-4 mb-8 text-black text-left leading-normal">If you wish to order catering, a message will be sent to our restaurant. The restaurant will then contact you to confirm your request. Please note some items takes some time to prepare and must be ordered within a feasible time frame. The restaurant is open for catering from 07.30 to 17.00, enjoy!</p>`;
                    if(catering_menu_url!=""){
                    html += `<a href="${catering_menu_url}" target="_blank"><button class="update-room rounded-full bg-secondary-light text-secondary-dark text-lg md:mx-4 cta">Catering menu</button></a>`;
                    }
                    }else{
	                    html+=`<h4 class="font-bold mt-8 text-center text-2xl alschlange text-secondary-dark">${catering_no_catering_str}</h4>`;
                    }
                    
			html += `
			</div>
                  <span class="rounded-full h-border bg-tertiary-dark inline-flex w-full my-12">&nbsp;</span>
                </div>
              <div class="md:px-20 px-0">
              <label for="staff-message" class="text-left text-black text-lg alschlange">Message to Epicenter</label>
              <textarea name="staff-message" class="staff-message dinpromedium mt-1 p-4 w-full min-h-80 bg-white rounded-lg" >${booking.messageToStaff != null ? booking.messageToStaff : ''}</textarea>
              <p class="mt-8 text-black text-left text-lg">If you have any special requirements or message to Epicenter, this message will be sent with an email to our staff.</p>
              </div>

             </div>
             <span class="rounded-full h-border bg-tertiary-dark w-full inline-flex my-12">&nbsp;</span>
             <div class="flex md:flex-row flex-col md:mt-8 mb-12 w-4/5 mx-auto">
             <button class="mt-4 cancel-this-booking rounded-full bg-transparent border-2 border-black text-black text-xl w-full md:mx-4 cta">CANCEL BOOKING</button>
             <button class="mt-4 update-room rounded-full bg-secondary-light text-secondary-dark text-xl w-full md:mx-4 cta">UPDATE BOOKING</button>
             </div>
             <p class="text-red text-xl md:mx-20 leading-tight md:leading-normal">This booking needs to be cancelled ${room.invoicingThreshold} hours before start time to not be invoiced. If cancelled after this time and up to one hour before the start, you will be partly invoiced. One hour before the meeting is due to start you will be invoiced in full.</p>

           </div>
           `;
        $bookingContainer.html(html);
      },
      error: function () {
        $bookingContainer.html('<h3 class="text-red text-4xl">404 - Your booking could not be found.</h3>');
      }
    });

    $('body').on('click', '.cancel-this-booking', function () {
      $.ajax({
        url: APIURL + 'bookings/' + bookingId,
        method: 'PUT',
        data: JSON.stringify({cancelled: 1}),
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', AUTH);
        },
        success: function (response) {
          window.location = HOME_URL;
        },
        error: function (error) {
          console.log(error);
        }

      });
    });
    $('body').on('click', '.edit-this-booking', function () {
      $(this).addClass('hidden');
      var $editview = $('.edit-view');
      $editview.addClass('flex').removeClass('hidden');
    });

    $('body').on('click', '.update-room', function () {

      var data = {
        catering: $('.catering-slider').prop('checked') ? 1 : 0,
        cateringRequest: $('.catering-message').val(),
        messageToStaff:  $('.staff-message').val(),
      };

      $.ajax({
        url: APIURL + 'bookings/' + bookingId,
        method: 'PUT',
        data: JSON.stringify(data),
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', AUTH);
        },
        success: function (response) {
          window.location.reload();
        },
        error: function (error) {
          console.log(error);
        }

      });
    });
    var $body = $('body');
    $body.on('click', '.catering-slider', function () {
      var $parent = $(this).parent('label');
      if ($parent.hasClass('active')) {
        $parent.removeClass('active');
      } else {
        $parent.addClass('active');
      }
      $('.catering-container').toggle();
    });
  }

}
